/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import jwtDecode from 'jwt-decode';
// import AES from 'crypto-js/aes';
// import { ENCRYPTION_KEY } from './config';
import moment from 'moment';

export const ACCESS_TOKEN = 'access';
export const REFRESH_TOKEN = 'refresh';

// Stores token into the memory
export function setToken(token) {
    // localStorage.setItem(ACCESS_TOKEN, JSON.stringify(AES.encrypt(token[ACCESS_TOKEN], ENCRYPTION_KEY)));
    // localStorage.setItem(REFRESH_TOKEN, JSON.stringify(AES.encrypt(token[REFRESH_TOKEN], ENCRYPTION_KEY)));

    setAccessToken(token[ACCESS_TOKEN]);
    localStorage.setItem(REFRESH_TOKEN, token[REFRESH_TOKEN]);
}

/* sets access token on login or on new token after expired */
export function setAccessToken(token) {
    localStorage.setItem(ACCESS_TOKEN, token);
}

// Gets access token from the stored memory
export function getToken(tokenType) {
    const token = localStorage.getItem(tokenType);
    if (!token) { 
        return null;
    }

    return token;
    // return AES.decrypt(JSON.parse(token), );
}

// gets the payload data from token
export function getPayload(tokenType) {
    const token = getToken(tokenType);
    if (token) {
        return jwtDecode(token);
    }

    return null;
}

// Removes tokens from the stored memory
export function unsetToken() {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
}

// returns token expiration date
export function getTokenExpiration(tokenType) {
    const decoded = jwtDecode(getToken(tokenType));

    return new Date(decoded.exp * 1000);
}

/* Checks whether token is expired or not */
export function isTokenExpired(tokenType) {
    if (!getToken(tokenType)) {
        return true;
    }
    return (getTokenExpiration(tokenType)).getTime() <= (new Date()).getTime();
}

// return token expiration date before one hour
export function getTokenExpirationBeforeOneHour(tokenType) {
    const decoded = jwtDecode(getToken(tokenType));

    let expMillis = decoded?.exp * 1000 // response not a valid time millis so converted to proper millis using *1000
    let expTime = moment(expMillis).subtract(30, "minutes")
    return new Date(expTime);
}

/* Checks whether token is expired or not */
export function isTokenExpiredBeforeOneHour(tokenType) {
    if (!getToken(tokenType)) {
        return true;
    }
    return (getTokenExpirationBeforeOneHour(tokenType)).getTime() <= (new Date()).getTime();
} 